/**
 *
 * @module geoProvider
 * @desc ATV GeoProvider
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';
import GeoLocation from './../../token/geoLocation';
import Exception from './../../services/exception/entry';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    number
} = Check.assert;

/**
 *
 * @class GeoProvider
 * @desc Defines the contract for a class that can provide the current GeoLocation of the device.
 * @todo
 *
 */
export default class GeoProvider {

    /**
     *
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(logger = Logging) {

        /**
         *
         * @access private
         * @type {SDK.Logging.Logger}
         *
         */
        this.logger = logger;

        this.logger.log(GeoProvider.name, 'Created GeoProvider.');

    }

    /**
     *
     * @access public
     * @method getGeoLocation
     * @param {Number} [timeout]
     * @returns {GeoLocation}
     *
     */
    getGeoLocation(timeout) {

        const errorMessage = {
            method: 'GeoProvider.getGeoLocation(timeout)',
            get timeout() {
                return `${this.method} timeout should be a Float`;
            }
        };

        if (Check.assigned(timeout)) {
            number(timeout, errorMessage.timeout, InvalidArgumentException);
        }

        return new Promise((resolve) => {
            return resolve(new GeoLocation(0, 0));
        });

    }

}



// WEBPACK FOOTER //
// ./src/platforms/apple/geoProvider.js